import { gql } from '@apollo/client'

export const GET_IPL_DATA = gql`
  query GetMajorSeriesData($input: getSeriesVenuesInput!) {
  getMajorSeriesData(input: $input) {
    aFixtures {
      _id
      sTitle
      sSubtitle
      sFormatStr
      oFormat {
        eType
        sCode
        sColor
        sText
        sValue
      }
      sStatusStr
      oStatus {
        eType
        sCode
        sColor
        sText
        sValue
      }
      sStatusNote
      dStartDate
      oVenue {
        sName
        sLocation
      }
      oTeamScoreA {
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
        }
        sScoresFull
        sScores
        sOvers
      }
      oTeamScoreB {
        sScoresFull
        sScores
        sOvers
        oTeam {
          oImg {
            sUrl
          }
          sAbbr
          _id
        }
      }
      matchFormatType
      matchFormat
      sLiveMatchNote
      oSeo {
        sSlug
      }
      iWinnerId
    }
    aSeriesStandings {
    bIsTeamQualified
      _id
      iSeriesId
      oTeam {
        _id
        sAbbr
        sCountry
        sAltName
        sCountryFull
        oSeo {
          sSlug
        }
        oImg {
          sUrl
        }
      }
      nPlayed
      nWin
      nDraw
      nLoss
      nNR
      nPoints
    }
    aTeams {
      _id
      sTitle
      sAbbr
      oSeo {
        sSlug
      }
      oImg {
        sUrl
      }
    }
    aVenues {
      _id
      sName
      sLocation
      sCountry
      sCity
      oSeo {
        sSlug
      }
    }
    dStartDate
    dEndDate
    nTotalMatches
    aWinners {
      nYear
      oImg {
        sUrl
      }
    }
  }
}
`

export const GET_BOUNDARIES_DATA = gql`
query GetBoundaries($input: getBoundariesInput!) {
  getBoundaries(input: $input) {
    iSeriesId
    nTotalFours
    nTotalSixes
    aTeamFours {
      oTeam {
        sTitle
        sAbbr
      }
      nCount
      aPlayers {
        nCount
        oPlayer {
          _id
          sFirstName
          sFullName
          sUrl
          oSeo {
            sSlug
          }
          oImg {
            sUrl
          }
        }
      }
    }
    aTeamSixes {
      oTeam {
        sTitle
        sAbbr
      }
      nCount
      aPlayers {
        nCount
        oPlayer {
          _id
          sFirstName
          sFullName
          sUrl
          oSeo {
            sSlug
          }
          oImg {
            sUrl
          }
        }
      }
    }
    oLatestFourPlayer {
      sFullName
      oImg {
        sUrl
      }
      oSeo {
        sSlug
      }
    }
    oLatestSixPlayer {
      sFullName
      oImg {
        sUrl
      }
      oSeo {
        sSlug
      }
    }
    aPlayerSixes {
      nCount
      oPlayer {
        _id
        sFullName
        oImg {
          sUrl
        }
        oSeo {
          sSlug
        }
      }
    }
    aPlayerFours {
      nCount
      oPlayer {
        _id
        sFullName
        oImg {
          sUrl
        }
        oSeo {
          sSlug
        }
      }
    }
  }
}
`

export const IPL_FANTASY_TIPS = gql`
  query ListFantasyTipsBySeriesIdFront($input: olistFantasyTipsBySeriesIdFrontInput) {
  listFantasyTipsBySeriesIdFront(input: $input) {
    aResults {
      aFantasyTips {
        oSeo {
          sSlug
        }
      }
      oSeo {
        sSlug
      }
      oTeamA {
        sTitle
        sAbbr
        oImg {
          sUrl
        }
      }
      oTeamB {
        sTitle
        sAbbr
         oImg {
          sUrl
        }
      }
      dStartDate
      oFormat {
        sText
      }
      sStatusNote
      sStatusStr
      sSubtitle
    }
  }
}
`
